
import { intl } from 'i18n/Translations';
import dayjs from 'dayjs';

export const getRouteFormatedTime = (seconds?: number) => {
  if (!seconds) {
    return '';
  }

  const hours = Math.floor(dayjs.duration(Math.abs(seconds), 'seconds').asHours());
  const minutes = dayjs.duration(Math.abs(seconds), 'seconds').minutes();

  return `${seconds < 0 ? '-' : ''}${hours} ${intl.formatMessage({ id: 'hours' })} ${minutes} ${intl.formatMessage({ id: 'min' })}`;
};
